const GIFT_CARD_SKUS = [
    {
        skuId: '00510',
        listPrice: '10'
    },
    {
        skuId: '00520',
        listPrice: '25'
    },
    {
        skuId: '00530',
        listPrice: '40'
    },
    {
        skuId: '00540',
        listPrice: '50'
    },
    {
        skuId: '00550',
        listPrice: '75'
    },
    {
        skuId: '00560',
        listPrice: '100'
    },
    {
        skuId: '00570',
        listPrice: '150'
    },
    {
        skuId: '00580',
        listPrice: '200'
    },
    {
        skuId: '00590',
        listPrice: '250'
    }
];

const BIRTHDAY_GIFT_CARD_SKUS = [
    {
        skuId: '00710',
        listPrice: '10'
    },
    {
        skuId: '00720',
        listPrice: '25'
    },
    {
        skuId: '00730',
        listPrice: '40'
    },
    {
        skuId: '00740',
        listPrice: '50'
    },
    {
        skuId: '00750',
        listPrice: '75'
    },
    {
        skuId: '00760',
        listPrice: '100'
    },
    {
        skuId: '00770',
        listPrice: '150'
    },
    {
        skuId: '00780',
        listPrice: '200'
    },
    {
        skuId: '00790',
        listPrice: '250'
    }
];

const THANK_YOU_GIFT_CARD_SKUS = [
    {
        skuId: '00810',
        listPrice: '10'
    },
    {
        skuId: '00820',
        listPrice: '25'
    },
    {
        skuId: '00830',
        listPrice: '40'
    },
    {
        skuId: '00840',
        listPrice: '50'
    },
    {
        skuId: '00850',
        listPrice: '75'
    },
    {
        skuId: '00860',
        listPrice: '100'
    },
    {
        skuId: '00870',
        listPrice: '150'
    },
    {
        skuId: '00880',
        listPrice: '200'
    },
    {
        skuId: '00890',
        listPrice: '250'
    }
];

const CELEBRATION_GIFT_CARD_SKUS = [
    {
        skuId: '00610',
        listPrice: '10'
    },
    {
        skuId: '00620',
        listPrice: '25'
    },
    {
        skuId: '00630',
        listPrice: '40'
    },
    {
        skuId: '00640',
        listPrice: '50'
    },
    {
        skuId: '00650',
        listPrice: '75'
    },
    {
        skuId: '00660',
        listPrice: '100'
    },
    {
        skuId: '00670',
        listPrice: '150'
    },
    {
        skuId: '00680',
        listPrice: '200'
    },
    {
        skuId: '00690',
        listPrice: '250'
    }
];

function isGiftCardError({ error }) {
    // Get the first key in the object, which instead of being a specific error
    // key related to a gift card SKU error, it's just the gift card SKU itself,
    // which makes this function necessary.
    const errorKeys = Object.keys(error).filter(key => key !== 'errorMessages');

    if (errorKeys.length === 0) {
        return false;
    }

    const errorKey = errorKeys[0];

    // Combine all SKUs into a single array
    const ALL_GIFT_CARD_SKUS = [...GIFT_CARD_SKUS, ...BIRTHDAY_GIFT_CARD_SKUS, ...THANK_YOU_GIFT_CARD_SKUS, ...CELEBRATION_GIFT_CARD_SKUS];

    return ALL_GIFT_CARD_SKUS.some(giftCard => giftCard.skuId === errorKey);
}

export {
    GIFT_CARD_SKUS, BIRTHDAY_GIFT_CARD_SKUS, THANK_YOU_GIFT_CARD_SKUS, CELEBRATION_GIFT_CARD_SKUS, isGiftCardError
};
